/* eslint-disable react/prop-types */
/* eslint-disable arrow-parens */
import { Box } from "@material-ui/core";
import PropTypes from "prop-types";

/**
 * TabPanel component to conditionally render content based on the selected tab.
 *
 * @param {object} props - The props for the TabPanel component.
 * @param {React.ReactNode} props.children - The content of the TabPanel.
 * @param {number} props.value - The currently selected tab index.
 * @param {number} props.index - The index of this TabPanel.
 * @returns {JSX.Element} The rendered TabPanel component.
 */
const ScrollToPannel = ({ children, value, index, ...other }) => {
	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box padding={3}>
					{" "}
					{/* Updated padding prop for MUI */}
					{children}
				</Box>
			)}
		</div>
	);
};

ScrollToPannel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.number.isRequired,
	value: PropTypes.number.isRequired
};

export default ScrollToPannel;
